import React from 'react';
import { defineMessages, FormattedMessage, type MessageValue } from 'react-intl';
import { StyleSheet } from 'react-native';

import { DisplayText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellLineItemHeader = (props: UpsellLineItemHeaderProps) => {
  const { lineItemName, quantity } = props;

  return (
    <DisplayText sizeMatch={['24']} bold style={styles.text}>
      <FormattedMessage
        {...messages.header}
        values={{ line_item_name: lineItemName, quantity: String(quantity) }}
      />
    </DisplayText>
  );
};

// ─────────────────────────────────────────────────────────────────────────────

const messages = defineMessages<{
  readonly header: { readonly line_item_name: MessageValue; readonly quantity: string };
}>({
  header: {
    defaultMessage: '{quantity, select, 1 {{line_item_name}} other {{quantity}x {line_item_name}}}',
    description: 'Upsell modal | Line item name',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    paddingTop: theme.spacing['8'],
  },
});

// ─────────────────────────────────────────────────────────────────────────────

type UpsellLineItemHeaderProps = {
  lineItemName: string;
  quantity: number;
};
